export const formatExpenseDate = (value?: string | null) => {
  if (!value) return '—'
  const date = new Date(`${value}T00:00:00`)
  if (Number.isNaN(date.getTime())) return value
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  })
}

/** Basename from s3://bucket/.../EXPENSE_n_original.pdf → original.pdf when possible. */
export const fileNameFromS3Path = (s3Path?: string | null) => {
  if (!s3Path) return null
  const basename = s3Path.split('/').pop()?.trim()
  if (!basename) return null
  const stripped = basename.replace(/^EXPENSE_\d+_/, '')
  return stripped || basename
}

export const formatExpenseAmount = (
  amount?: number | null,
  currency?: string | null
) => {
  if (amount == null) return '—'
  const formatted = amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  return `$${formatted}${currency ? ` ${currency}` : ''}`
}

export const formatMoneyDisplay = (value?: number | null) => {
  if (value == null || Number.isNaN(value)) return ''
  return value.toFixed(2)
}

export const sumLineAmounts = (
  lineItems: Array<{ amount?: number | null }>
) => {
  const total = lineItems.reduce((sum, item) => sum + (item.amount ?? 0), 0)
  return Number(total.toFixed(2))
}

export const resolveUnitPrice = (
  unitPrice?: number | null,
  amount?: number | null,
  quantity?: number | null
) => {
  if (unitPrice != null) return unitPrice
  if (amount != null && quantity != null && quantity !== 0) {
    return Number((amount / quantity).toFixed(2))
  }
  return null
}
